import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'

type Entity = {
  type: 'borrower' | 'main_partner' | 'partner'
  name: string
  email?: string
}

export async function readFiscalNoteEntities(fiscalNoteKey: string) {
  const response = await httpClient('accounting-dealer').get<Entity[]>(
    `/v3/fiscal-note/${fiscalNoteKey}/entities`,
  )

  return response.data
}

export function useReadFiscalNoteEntities(
  fiscalNoteKey: string,
  options?: Partial<UseQueryOptions<Entity[]>>,
) {
  return useQuery({
    queryKey: ['fiscal-note-entities', fiscalNoteKey],
    queryFn: () => readFiscalNoteEntities(fiscalNoteKey),
    ...options,
  })
}
